import { useMemo } from 'react';
import { identity } from 'lodash';
import { useDimension } from 'hooks';
import { isStaticReport } from '../../../config/isStaticDynamicReport';
import { resolveReportIdByCampaignDimension } from '../../../config/resolveReportIdByCampaignDimension';
import { getDefaultReportId } from './getDefaultReportId';
import useAvailableReports from './useAvailableReports';
import { useSelectedReportId } from './useSelectedReportId';

export const useFallbackReportId = reportConfigMap => {
    const [selectedReport] = useSelectedReportId();
    const [dimension] = useDimension();
    const { availableReports, isReportVisible = identity } = useAvailableReports(reportConfigMap);

    const matchedReportId = useMemo(() => {
        const reportId = selectedReport || '';
        const reportTypeTwin = resolveReportIdByCampaignDimension(reportId, dimension);
        const newReportId = reportId !== reportTypeTwin && isStaticReport(reportTypeTwin) && reportTypeTwin;

        if (isReportVisible(newReportId)) {
            return newReportId;
        }

        const defaultReportId = getDefaultReportId(dimension);
        if (!isReportVisible(defaultReportId)) {
            return availableReports[0]?.id;
        }

        return defaultReportId;
    }, [selectedReport, dimension, isReportVisible, availableReports]);

    return matchedReportId;
};
